import { API_BASE } from "../../utils/api";

function getApiOrigin() {
  if (!API_BASE) return "";
  try {
    return new URL(API_BASE).origin;
  } catch {
    return String(API_BASE).replace(/\/+$/, "");
  }
}

async function fetchSiteContent(path) {
  const origin = getApiOrigin();
  if (!origin) {
    throw new Error("No está configurada la URL del API");
  }
  const response = await fetch(`${origin}${path}`);
  if (!response.ok) {
    throw new Error("Error al cargar el contenido");
  }
  return response.json();
}

export function getGlosario() {
  return fetchSiteContent("/api/glosario/");
}

export function getPreguntasFrecuentes() {
  return fetchSiteContent("/api/preguntas-frecuentes/");
}

export function getDocumentosInteres() {
  return fetchSiteContent("/api/documentos-interes/");
}

export function getRecursosEducativos() {
  return fetchSiteContent("/api/recursos-educativos/");
}

export function getHomeNoticias() {
  return fetchSiteContent("/api/noticias/");
}
